import {DownOutlined, LoadingOutlined, UpOutlined} from "@ant-design/icons";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import GetLeadingQuestionsFromAssistantMessageModal from "../modals/GetLeadingQuestionsFromAssistantMessage-modal";


const SwitchableMessageText = ({title, message, hashtags, id, messagesList}) => {
	const {t} = useTranslation();
	const [isMinify, setIsMinify] = useState(false);
	const toggleVisibilitySize = () => setIsMinify(p=>!p)
	return (
			<>
				<pre
						className='block !text-sm text-wrap text-pretty max-w-full font-inherit text-inherit mb-2.5'
				>
					{isMinify ? `${message?.slice(0, 100)}...` : message}
				</pre>
				<span className='cursor-pointer absolute p-2 -bottom-1 right-1 text-black/25 hover:text-black/50' onClick={toggleVisibilitySize}>
					{isMinify ? <DownOutlined className='cursor-pointer' />: <UpOutlined className='cursor-pointer' />}
				</span>
				<div className='mb-6 mt-4 flex flex-wrap justify-between gap-2 items-center'>
					<div className='text-xs flex items-center gap-1 flex-wrap font-light'>
						{Array.isArray(hashtags)? hashtags?.map((hashtag, index) => (
							<span key={index} className='bg-gray-300 text-white px-2 py-0.5 rounded-lg'>
								{hashtag}
							</span>
						)) : hashtags}
					</div>
						<GetLeadingQuestionsFromAssistantMessageModal title={title} message={message} id={id} messagesList={messagesList}/>
				</div>
			</>
	);
};

export default SwitchableMessageText;